import { field, date, relation, children,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { GROUP_SCHEMA } from '../schema';

export default class GROUP extends Model {
    static table = GROUP_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        group_payment_ledger: { type: 'has_many', foreignKey: 'group_id' },
        group_customers: { type: 'has_many', foreignKey: 'group_id' },
        group_payments: { type: 'has_many', foreignKey: 'group_id' },
    }

    @field('payment_received') payment_received;
    @text('image_url') image_url;
    @field('amount') amount;
    @field('count') count;
    @text('name') name;
    @text('type') type;


    @date('collect_at') collect_at;

    @relation('business', 'business_id') business;

    @children('group_payment_ledger') group_payment_ledger;
    @children('group_customers') group_customers;
    @children('group_payments') group_payments;

};